import HeroLanding from "./HeroLanding";
export default HeroLanding;